import { Button } from "shared/ui/button";
import { useMobile } from "shared/lib/hooks";
import styles from "./Pagination.module.scss";
import PrevBtn from "shared/assets/images/PaginationPrev.svg";
import NextBtn from "shared/assets/images/PaginationNext.svg";

export const Pagination = ({ page, totalPages, onPageChange }) => {
  const isMobile = useMobile("670px");
  const maxButtonsCount = isMobile ? 3 : 5;

  if (totalPages <= 1) return null;

  const goToPage = (nextPage) => {
    if (nextPage < 1 || nextPage > totalPages || nextPage === page) return;
    onPageChange(nextPage);
  };

  const visiblePages = Math.min(maxButtonsCount, totalPages);

  return (
    <nav className={styles.pagination} aria-label="Пагинация">
      <div className={styles.pagination__btnBlock}>
        <Button
          variant="pagination"
          size="none"
          onClick={() => goToPage(page - 1)}
          disabled={page === 1}
          leftIcon={<img src={PrevBtn} alt="prev" />}
        />
      </div>

      {Array.from({ length: visiblePages }, (_, index) => index + 1).map(
        (item) => (
          <button
            key={item}
            type="button"
            className={`${styles.pagination__button} ${
              item === page ? styles.pagination__buttonActive : ""
            }`}
            onClick={() => goToPage(item)}
            aria-current={item === page ? "page" : undefined}
          >
            {item}
          </button>
        ),
      )}

      {totalPages > maxButtonsCount && (
        <button
          type="button"
          className={styles.pagination__button}
          onClick={() => goToPage(totalPages)}
          aria-label="Перейти на последнюю страницу"
        >
          ...
        </button>
      )}
      <div className={styles.pagination__btnBlock}>
        <Button
          variant="pagination"
          size="none"
          onClick={() => goToPage(page + 1)}
          disabled={page === totalPages}
          leftIcon={<img src={NextBtn} alt="next" />}
        />
      </div>
    </nav>
  );
};
